module.exports = __webpack_public_path__ + "static/media/cil-group.cd7cca1a.svg";